import React, {useState} from 'react';
import {ActionButton, ContentWrapper, DropdownWrapper, TagContentWrapper, Tags, TextInput} from './TagPicker.style';
import {t} from 'i18next';
import {getFontSize, isValidText} from '../../utils';
import {generateIdentifier} from '../../utils/IdentityUtils';

export interface TagSelectionProps {
    readonly dataSource: string[];
    onChange: (changedTags: string[]) => void;
}

/**
 * @name TagPicker
 * @description
 * Component to make a selection of string tags that can describe an item
 */
export const TagPicker: React.VFC<TagSelectionProps> = (props) => {
    const [tagInput, setTagInput] = useState('');

    const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        let eventValue = e.target.value.toString();
        setTagInput(eventValue);
    };

    const handleSave = () => {
        if (validateInput()) {
            let tag = tagInput.trim();
            if (props.dataSource) {
                props.onChange([...props.dataSource, tag]);
            } else {
                props.onChange([tag]);
            }

            setTagInput('');
        }
    };

    const validateInput = (): boolean => {
        return (isValidText(tagInput) && (!props.dataSource.includes(tagInput))) as boolean;
    }

    const handleDelete = (tagDelete: string) => {
        if (!props.dataSource) {
            return;
        }

        props.onChange(props.dataSource.filter(tagKeep => (tagKeep !== tagDelete)));
    };

    let fontSize = getFontSize([
        t('TAG_SELECTION_COMPONENT_ADD_LABEL')
    ], 2);

    return (
        <ContentWrapper id={generateIdentifier()}>
            <DropdownWrapper id={generateIdentifier()}>
                <TextInput id={generateIdentifier('inputIdTag')}
                           label={t('TAG_SELECTION_COMPONENT_FILE_TAG_LABEL')}
                           value={tagInput}
                           onChange={handleInput}
                           onKeyDown={(event) => {
                               if (event.key === 'Enter') {
                                   handleSave();
                               }
                           }}/>
                <ActionButton id={generateIdentifier()}
                              key='add'
                              icon='add'
                              mode='primary'
                              disabled={!validateInput()}
                              type='button'
                              label={t('TAG_SELECTION_COMPONENT_ADD_LABEL')}
                              title={t('TAG_SELECTION_COMPONENT_ADD_LABEL')}
                              fontSize={fontSize}
                              onClick={handleSave}/>
            </DropdownWrapper>
            <TagContentWrapper id={generateIdentifier()}>
                {props.dataSource.map(tag => {
                    return <Tags id={generateIdentifier()}
                                 key={tag}
                                 label={tag}
                                 buttonClose
                                 onClose={() => handleDelete(tag)}/>;
                })}
            </TagContentWrapper>
        </ContentWrapper>
    );
};
